import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { ClubShopButton } from '@sorare/core/src/components/clubShop/ClubShopButton';
import { CoinAmount } from '@sorare/core/src/components/clubShop/CoinAmount';
import { FOOTBALL_CLUB_SHOP } from '@sorare/core/src/constants/__generated__/routes';
import { useCoinBalance } from '@sorare/core/src/hooks/clubShop/useCoinBalance';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

import bannerBg from './assets/banner.png';

const Root = styled(Container)`
  background: no-repeat top center url(${bannerBg});
  padding: 0 var(--unit) var(--triple-unit) var(--unit);
`;
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${tabletAndAbove} {
    align-items: stretch;
    padding: var(--unit);
  }
  @media ${laptopAndAbove} {
    align-items: stretch;
    padding: var(--unit) 0;
  }
`;
const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 var(--unit);
  gap: var(--double-unit);

  @media ${tabletAndAbove} {
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
  }
`;

const Col = styled(Vertical).attrs({ gap: 0 })``;

const CoinBalanceCol = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: var(--double-unit);
  justify-content: flex-end;

  @media ${tabletAndAbove} {
    display: inline-flex;
    flex-direction: column;
    gap: var(--unit);
    align-items: flex-end;
  }
`;

const UnderlinedText = styled(LabelM)`
  text-decoration: underline;
`;

export const Header = () => {
  const { coinBalance } = useCoinBalance();
  return (
    <Root>
      <MainContainer>
        <FlexContainer>
          <Col>
            <LabelM color="var(--c-nd-600)">
              <FormattedMessage
                id="ClubShop.Header.Subtitle"
                defaultMessage="Redeem Coins to customize your profile, improve your cards, get tickets, merch, and more!"
              />
            </LabelM>
          </Col>
          <CoinBalanceCol>
            <Link
              to="https://sorare.com/blog/club-shop-finale-sweepstakes-the-sweepstakes"
              target="_blank"
              rel="noreferrer"
            >
              <UnderlinedText color="var(--c-white)">
                <FormattedMessage
                  id="ClubShop.Header.clubShopRules"
                  defaultMessage="Club Shop Rules"
                />
              </UnderlinedText>
            </Link>
            <ClubShopButton to={FOOTBALL_CLUB_SHOP}>
              <CoinAmount amount={coinBalance} />
            </ClubShopButton>
          </CoinBalanceCol>
        </FlexContainer>
      </MainContainer>
    </Root>
  );
};
